import { Input } from "@/shared/components/shadcn/Input";
import { Select } from "@/shared/components/shadcn/Select";
import { FormField } from "@/shared/components/ui/FormField";
import { usStates } from "@/shared/utils/usStates";

interface LocationAddressFieldsProps {
  value: { address: string; city: string; state: string; postalCode: string };
  onChange: (value: LocationAddressFieldsProps["value"]) => void;
}

export function LocationAddressFields({ value, onChange }: LocationAddressFieldsProps) {
  const validState = !value.state || usStates.some(([code]) => code === value.state);
  return (
    <div className="space-y-[18px]">
      <FormField id="street-address" label="Street address">
        <Input autoComplete="street-address" value={value.address} onChange={(event) => onChange({ ...value, address: event.target.value })} />
      </FormField>
      <FormField id="city" label="City">
        <Input autoComplete="address-level2" value={value.city} onChange={(event) => onChange({ ...value, city: event.target.value })} />
      </FormField>
      <div className="grid gap-[18px] sm:grid-cols-2">
        <FormField id="state" label="State">
          <Select autoComplete="address-level1" value={value.state} aria-invalid={!validState} onChange={(event) => onChange({ ...value, state: event.target.value })}>
            <option value="">Select a state</option>
            {!validState && <option value={value.state} disabled>Unsupported state: {value.state}</option>}
            {usStates.map(([code, name]) => <option key={code} value={code}>{name}</option>)}
          </Select>
        </FormField>
        <FormField id="postal-code" label="Postal code">
          <Input autoComplete="postal-code" value={value.postalCode} onChange={(event) => onChange({ ...value, postalCode: event.target.value })} />
        </FormField>
      </div>
    </div>
  );
}
